import {nameofFactory} from 'web-app/util/typescript';

import {type AuthChallengeFragment} from './__generated__/queries.api-types';

export interface OpenConnectIdInfo {
    required: boolean;
    url: string;
    params: {[key: string]: string};
    title: string;
    clientId: string;
    openIDProviderId: string;
}

export interface ExistingLogin {
    baseUrl: string;
    exists: boolean;
    local: boolean;
    passwordLoginAvailable: boolean;
    passwordlessLoginAvailable: boolean;
    useGraphQLAuthentication: boolean;
    useUserContextAuthentication: boolean;
    useOpenIdConnect?: OpenConnectIdInfo[];
    canRequestOpenIdConnectToken: boolean;
    canResetPassword?: boolean;
    canUseOneTimePassword?: boolean;
}

export interface LoginSelectorOption {
    label: ExistingLogin['baseUrl'];
    value: ExistingLogin['baseUrl'];
    local: ExistingLogin['local'];
}

export interface LoginFormData {
    email: string;
    password: string;
    loginTLD?: string;
    shouldUseUserContext?: boolean;
    shouldPingAllServers?: boolean;
}

export const fieldNames = nameofFactory<LoginFormData>();

export interface ForgotPasswordFormData {
    email: string;
    oneTimePassword?: string;
}

export interface ResetPasswordFormData {
    password: string;
    password2: string;
}

export interface Account {
    email: string;
    image: string;
    lastLogin: string;
    loginId: string;
    name: {
        salutation: string | null;
        firstName: string;
        middleName: string | null;
        lastName: string | null;
        fullName: string;
    };
    useGraphQLAuthentication?: boolean;
    useUserContextAuthentication?: boolean;
}

export enum LoadingState {
    Success = 'Success',
    Error = 'Error',
    Loading = 'Loading',
}

export enum LoginErrorState {
    INVALID_PIN = 1446024990,
    INVALID_PASSWORD = 1441363022,
    EMAIL_DOES_NOT_EXIST = 1441363021,
    TOO_MANY_PIN_ATTEMPTS = 1461843752,
    TOO_MANY_CREDENTIAL_APPEMPTS = 1456315879,
    TWO_FACTOR_REQUIRED = 1525435016,
    FORCE_CREDENTIAL_LOGIN = 1446024988,
    INVALID_EMAIL = 1441363020,
}

export interface LoginError {
    error: string;
    title?: string;
    description?: string;
    errorCode: LoginErrorState;
}
export type ChallengeContext = AuthChallengeFragment;
